import { useNavigate } from "react-router-dom";
import {
    Ban,
    ShieldCheck,
    Trash2,
} from "lucide-react";

import {
    blockCustomer,
    unblockCustomer,
    deleteCustomer,
} from "../../services/adminApi";

import "./CustomerActionButtons.css";

function CustomerActionButtons({ customer, reload }) {

    const navigate = useNavigate();

    const handleBlock = async () => {

        if (!window.confirm("Are you sure you want to block this customer?"))
            return;

        try {

            await blockCustomer(customer._id);

            alert("Customer blocked successfully.");

            reload();

        } catch (error) {

            console.error(error);

            alert("Failed to block customer.");

        }

    };

    const handleUnblock = async () => {

        if (!window.confirm("Are you sure you want to activate this customer?"))
            return;

        try {

            await unblockCustomer(customer._id);

            alert("Customer activated successfully.");

            reload();

        } catch (error) {

            console.error(error);

            alert("Failed to activate customer.");

        }

    };

    const handleDelete = async () => {

        if (
            !window.confirm(
                "This action cannot be undone.\n\nDelete this customer?"
            )
        )
            return;

        try {

            await deleteCustomer(customer._id);

            alert("Customer deleted successfully.");

            navigate("/admin/customers");

        } catch (error) {

            console.error(error);

            alert("Failed to delete customer.");

        }

    };

    return (

        <div className="customer-card">

            <h2 className="customer-card-title">

                Customer Actions

            </h2>

            <div className="customer-action-buttons">

                {customer.isActive ? (

                    <button
                        className="block-btn"
                        onClick={handleBlock}
                    >

                        <Ban size={18} />

                        Block Customer

                    </button>

                ) : (

                    <button
                        className="activate-btn"
                        onClick={handleUnblock}
                    >

                        <ShieldCheck size={18} />

                        Activate Customer

                    </button>

                )}

                <button
                    className="delete-btn"
                    onClick={handleDelete}
                >

                    <Trash2 size={18} />

                    Delete Customer

                </button>

            </div>

        </div>

    );

}

export default CustomerActionButtons;